import React, { useState, useEffect } from 'react'
import { Panel, Grid, Row, Placeholder, Table, Checkbox } from 'rsuite'

export default function BackgroundReduceSmokingView({ schema }) {
  const { Graph } = Placeholder
  const { Column, HeaderCell, Cell, ColumnGroup } = Table

  const [dataConsumeSmoking, setDataConsumeSmoking] = useState([])
  const [smokerPerSex, setSmokerPerSex] = useState([])
  const [shopPerActs, setShopPerActs] = useState([])
  const [shopAmount, setShopAmount] = useState(0)

  useEffect(() => {
    var smokerArr = [
      {
        sex: 'ชาย',
        smoking: schema.smokerMale.value,
        noneSmoking: schema.noneSmokerMale.value,
      },
      {
        sex: 'หญิง',
        smoking: schema.smokerFemale.value,
        noneSmoking: schema.noneSmokerFemale.value,
      },
      {
        sex: 'รวม',
        smoking: schema.noneSmokerMale.value + schema.smokerFemale.value,
        noneSmoking: schema.smokerMale.value + schema.noneSmokerMale.value,
        summary: true,
      },
    ]

    let shopPerActs = []
    let shopCount = 0
    schema.shopInfo.acts.forEach((item) => {
      let macth
      schema.shopInfo.value.forEach((value) => {
        if (item.id == value.act.id) {
          value.shops.length > shopCount && (shopCount = value.shops.length)
          shopPerActs.push({ act: item, shops: [...value.shops] })
          macth = true
          return
        }
      })

      !macth && shopPerActs.push({ act: item, shops: [] })
    })

    setShopPerActs(shopPerActs)
    setShopAmount(shopCount)

    setDataConsumeSmoking([schema.allHousehold, schema.allHouseholdSmoking])
    setSmokerPerSex(smokerArr)
  }, [schema])

  const paragraph = <>&nbsp; &nbsp; &nbsp;</>

  const genColumnShop = () => {
    console.log('shopAmount', shopAmount)
    const element = []
    for (let shop = 0; shop < shopAmount; shop++) {
      element.push(
        <Column width={120} align="center" key={shop}>
          <HeaderCell>ร้านที่ {shop + 1}</HeaderCell>
          <Cell style={{ display: 'flex', justifyContent: 'center' }}>
            {(rowData) => {
              return <Checkbox checked={rowData.shops[shop]} disabled={true} />
            }}
          </Cell>
        </Column>
      )
    }

    return element
  }
  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row style={styles.marginTop10}>
            <p>{schema.generalInfo.label}</p>

            {schema.generalInfo.value ? (
              <div
                style={styles.detailParagraph}
                dangerouslySetInnerHTML={{ __html: schema.generalInfo.value }}
              />
            ) : (
              <div style={styles.detailParagraph}>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          <Row style={styles.marginTop10}>
            <p>{schema.environment.label}</p>

            {schema.environment.value ? (
              <div
                style={styles.detailParagraph}
                dangerouslySetInnerHTML={{ __html: schema.environment.value }}
              />
            ) : (
              <div style={styles.detailParagraph}>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          <Row style={styles.marginTop10}>
            <p>{schema.shopInfo.label}</p>
            <Table
              wordWrap
              autoHeight
              bordered
              headerHeight={50}
              data={shopPerActs}
              style={{ marginTop: '3px' }}
            >
              <Column width={20} fixed>
                <HeaderCell></HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>
              <Column width={380} fixed>
                <HeaderCell>พรบ.ยาสูบ 2560</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.act.act
                  }}
                </Cell>
              </Column>
              {genColumnShop()}
            </Table>
          </Row>

          <Row style={styles.marginTop10}>
            <p>
              {schema.nonSmokingPlace.label} {schema.nonSmokingPlace.preLabel}{' '}
              <u>
                <b>{schema.nonSmokingPlace.value ? schema.nonSmokingPlace.value : paragraph} </b>
              </u>{' '}
              {schema.nonSmokingPlace.postLabel} {schema.nonSmokingPlaceDetail.label}
            </p>
            {schema.nonSmokingPlaceDetail.value ? (
              <div
                style={styles.detailParagraph}
                dangerouslySetInnerHTML={{ __html: schema.nonSmokingPlaceDetail.value }}
              />
            ) : (
              <div style={styles.detailParagraph}>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          {/* <Row style={styles.marginTop10}>
            {schema.nonSmokingPlaceDetail.value ? (
              <div dangerouslySetInnerHTML={{ __html: schema.nonSmokingPlaceDetail.value }} />
            ) : (
              <div>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row> */}

          <Row style={styles.marginTop10}>
            <p>{schema.tobaccoCigarette.label}</p>

            {schema.tobaccoCigarette.value ? (
              <div
                style={styles.detailParagraph}
                dangerouslySetInnerHTML={{ __html: schema.tobaccoCigarette.value }}
              />
            ) : (
              <div style={styles.detailParagraph}>
                <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                <Graph height={9} />
                <Graph height={9} />
              </div>
            )}
          </Row>

          <Row style={styles.marginTop10}>
            <p>
              {schema.smokingProblem.label} {schema.smokingProblemView.label1}{' '}
              <b> {schema.smokingProblemVillage.value}</b> {schema.smokingProblemView.label2}
            </p>
            <p style={styles.headerText}>{schema.smokingProblemView.label3}</p>
          </Row>

          <Row style={styles.marginTop10}>
            <p style={styles.headerText}>{schema.householdSmoking.label}</p>
            <Table
              bordered
              cellBordered
              autoHeight
              width={920}
              style={{ marginTop: '3px' }}
              headerHeight={80}
              data={dataConsumeSmoking}
              onRowClick={(data) => {
                console.log(data)
              }}
            >
              <Column width={520} align="center" fixed>
                <HeaderCell style={styles.styleHeaderTable}>ข้อมูล</HeaderCell>
                <Cell dataKey="label" />
              </Column>
              <ColumnGroup header={schema.smokingProblemView.label4} align="center">
                <Column width={200} colSpan={2}>
                  <HeaderCell style={styles.styleHeaderTable}>จำนวน</HeaderCell>
                  <Cell dataKey="value" />
                  {/* <Cell>
                    {
                      (rowData)=>{
                        return rowData.value && (rowData.value.fixed(2))
                      }
                    }
                  </Cell> */}
                </Column>
                <Column width={200}>
                  <HeaderCell style={styles.styleHeaderTable}>คิดเป็นร้อยละ</HeaderCell>
                  <Cell>
                    {(rowData) => {
                      var percent = rowData.value
                        ? ((rowData.value * 100) / schema.allHousehold.value).toFixed(2)
                        : '00.00'
                      return percent + ' %'
                    }}
                  </Cell>
                </Column>
              </ColumnGroup>
            </Table>
          </Row>

          <Row style={styles.marginTop10}>
            <p style={styles.headerText}>{schema.smoker.label}</p>
            <Table
              bordered
              cellBordered
              autoHeight
              width={920}
              style={{ marginTop: '3px' }}
              data={smokerPerSex}
            >
              <Column width={150}>
                <HeaderCell></HeaderCell>
                <Cell dataKey="" />
              </Column>
              <Column width={200} align="center">
                <HeaderCell>เพศ</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.summary ? <b>{rowData.sex}</b> : rowData.sex
                  }}
                </Cell>
              </Column>
              <Column width={200} align="center">
                <HeaderCell>สูบบุหรี่ (คน)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.summary ? <b>{rowData.smoking}</b> : rowData.smoking
                  }}
                </Cell>
              </Column>
              <Column width={200} align="center">
                <HeaderCell>ไม่สูบบุหรี่ (คน)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return rowData.summary ? <b>{rowData.noneSmoking}</b> : rowData.noneSmoking
                  }}
                </Cell>
              </Column>
            </Table>
          </Row>

          <Row style={styles.marginTop10}>
            <p>{schema.problemOfSmoking.label}</p>
            {schema.problemOfSmoking.value.length == 0 && <p style={styles.marginLeft10}>ไม่มี</p>}
            {schema.problemOfSmoking.value.map((item) => {
              return (
                <div style={{ marginLeft: 10 }}>
                  {schema[item].preLabel}
                  {schema[item].value ? (
                    <div
                      style={{ marginLeft: 10 }}
                      dangerouslySetInnerHTML={{ __html: schema[item].value }}
                    />
                  ) : (
                    <div>
                      <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                      <Graph height={9} />
                      <Graph height={9} />
                    </div>
                  )}
                </div>
              )
            })}
          </Row>

          <Row style={styles.marginTop10}>
            <p>{schema.controlCigarette.label}</p>
            {schema.controlCigarette.options.map((item) => {
              if (item.value == schema.controlCigarette.value) {
                return (
                  <Row style={styles.marginLeft10}>
                    {item.label}
                    {item.value == 1 && (
                      <>
                        <Row style={styles.marginTop10}>
                          {schema.howControlCigarette.label}
                          {schema.howControlCigarette.value ? (
                            <div
                              dangerouslySetInnerHTML={{ __html: schema.howControlCigarette.value }}
                            />
                          ) : (
                            <div>
                              <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                              <Graph height={9} />
                              <Graph height={9} />
                            </div>
                          )}
                        </Row>
                        <Row style={styles.marginTop10}>
                          {schema.resultControlCigarette.label}
                          {schema.resultControlCigarette.value ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: schema.resultControlCigarette.value,
                              }}
                            />
                          ) : (
                            <div>
                              <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                              <Graph height={9} />
                              <Graph height={9} />
                            </div>
                          )}
                        </Row>
                        <Row style={styles.marginTop10}>
                          {schema.obstacleControlCigarette.label}
                          {schema.obstacleControlCigarette.value ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: schema.obstacleControlCigarette.value,
                              }}
                            />
                          ) : (
                            <div>
                              <Graph height={9} width={'95%'} style={{ marginLeft: '1em' }} />
                              <Graph height={9} />
                              <Graph height={9} />
                            </div>
                          )}
                        </Row>
                      </>
                    )}
                  </Row>
                )
              }
            })}
          </Row>

          <Row style={styles.marginTop10}>
            <p>
              {schema.village.label}{' '}
              <u>
                <b>{schema.village.value} </b>
              </u>
              {schema.province.label}{' '}
              <u>
                <b>{schema.addressInfo.provinceName} </b>
              </u>
              {schema.district.label}{' '}
              <u>
                <b>{schema.addressInfo.districtName} </b>
              </u>
              {schema.subDistrict.label}{' '}
              <u>
                <b>{schema.addressInfo.subDistrictName} </b>
              </u>
              <div
                dangerouslySetInnerHTML={{
                  __html: schema.finalText,
                }}
              />
            </p>
          </Row>
        </Grid>
      </Panel>
    </>
  )
}

const styles = {
  marginTop10: {
    marginTop: 10,
  },
  marginLeft10: {
    marginLeft: 10,
  },
  marginTop20: {
    marginTop: 20,
  },
  styleHeaderTable: {
    whiteSpace: 'normal',
  },
  detailParagraph: {
    marginLeft: 10,
  },
  headerText: {
    fontWeight: 'bold',
  },
}
